import {inject} from '@angular/core';
import {HttpInterceptorFn} from '@angular/common/http';
import {catchError, throwError} from 'rxjs';
import {ModalDynamicV3Service} from '../../shared-modal-dynamic/services/modal-dynamic-v3-service.service';
import {InfoModalModel} from '../../shared-modal-dynamic/models/info-modal-model';
import {ErrorModel} from '../../modules/auth/models/error-model';
import {InfoModalComponent} from '../../shared-modal-dynamic/components/info-modal/info-modal.component';

export const httpErrorInterceptorFn: HttpInterceptorFn = (req, next) => {
    const modalDynamicV3Service: ModalDynamicV3Service = inject(ModalDynamicV3Service);

    return next(req).pipe(
        catchError((error) => {
            console.log('Error caught in interceptor:', error);

            let model: InfoModalModel;

            if (!(error?.error as ErrorModel).errorType) {
                switch (error.status) {
                    case 500:
                        model = {
                            title: '500 - Interner Fehler',
                            htmlMessage: 'Auf dem Server ist ein unerwarteter Fehler aufgetreten. Bitte laden Sie die Seite neu oder versuchen Sie es später erneut.',
                            confirmButtonLabel: 'Verstanden'
                        };
                        break;
                    case 401:
                        model = {
                            title: '401 - Anmeldung erforderlich',
                            htmlMessage: 'Sie sind nicht angemeldet oder Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
                            confirmButtonLabel: 'Verstanden'
                        };
                        break;
                    case 403:
                        model = {
                            title: '403 - Zugriff verweigert',
                            htmlMessage: 'Sie haben keine Berechtigung für diese Aktion. Kontaktieren Sie den Administrator, falls Sie Zugriff benötigen.',
                            confirmButtonLabel: 'Verstanden'
                        };
                        break;
                    case 404:
                        model = {
                            title: '404 - Ressource nicht gefunden',
                            htmlMessage: 'Die angeforderte Seite oder Ressource ist nicht verfügbar. Prüfen Sie bitte die URL oder wenden Sie sich an den Administrator.',
                            confirmButtonLabel: 'Verstanden'
                        };
                        break;

                    case 400:
                        // Do nothing for 400
                        break;
                    default:
                        model = {
                            title: 'Unerwarteter Fehler',
                            htmlMessage: 'Es ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
                            confirmButtonLabel: 'Verstanden'
                        };
                        break;
                }
            }

            if (model) {
                modalDynamicV3Service.open(InfoModalComponent, {model: model});
            }

            return throwError(() => error);
        })
    );
};
